{
  "about.blocks": "受管制的伺服器",
  "about.contact": "聯絡我們：",
  "about.default_locale": "預設",
  "about.domain_blocks.no_reason_available": "沒有原因",
  "about.domain_blocks.preamble": "Mastodon 通常也讓你查看聯邦宇宙中各伺服器的內容，並與使用者互動。這些是發生在這個特定伺服器上的例外情況。",
  "about.domain_blocks.silenced.explanation": "一般來說您不會看到來自這個伺服器的個人檔案和內容，除非您明確地打開或著追蹤此個人檔案。",
  "about.domain_blocks.silenced.title": "受限",
  "about.domain_blocks.suspended.explanation": "來自此伺服器的所有資料都不會被處理、儲存或交換，因此不可能從此伺服器跟使用者互動或交流。",
  "about.domain_blocks.suspended.title": "已停權",
  "about.language_label": "語言",
  "about.not_available": "本伺服器尚未提供這資訊。",
  "about.powered_by": "由 {mastodon} 提供之去中心化社交媒體",
  "about.rules": "伺服器規則",
  "account.account_note_header": "個人筆記",
  "account.activity": "活動",
  "account.add_note": "新增個人筆記",
  "account.add_or_remove_from_list": "從列表中新增或移除",
  "account.badges.admin": "管理員",
  "account.badges.blocked": "已封鎖",
  "account.badges.bot": "機械人",
  "account.badges.domain_blocked": "已封鎖的網域",
  "account.badges.group": "群組",
  "account.badges.muted": "已靜音",
  "account.badges.muted_until": "靜音至 {until}",
  "account.block": "封鎖 @{name}",
  "account.block_domain": "封鎖網域 {domain}",
  "account.block_short": "封鎖",
  "account.blocked": "已封鎖",
  "account.cancel_follow_request": "撤回追蹤請求",
  "account.copy": "複製個人檔案連結",
  "account.direct": "私下提及 @{name}",
  "account.disable_notifications": "當 @{name} 發文時不要再通知我",
  "account.edit_note": "編輯個人筆記",
  "account.edit_profile": "修改個人檔案",
  "account.edit_profile_short": "編輯",
  "account.enable_notifications": "當 @{name} 發文時通知我",
  "account.endorse": "在個人檔案中推薦對方",
  "account.familiar_followers_many": "{name1}、{name2} 及{othersCount, plural, other {你認識的 # 人}}已追蹤",
  "account.familiar_followers_one": "{name1} 已追蹤",
  "account.familiar_followers_two": "{name1} 及 {name2} 已追蹤",
  "account.featured": "精選",
  "account.featured.accounts": "個人檔案",
  "account.featured.collections": "珍藏",
  "account.field_overflow": "顯示全部內容",
  "account.filters.all": "所有活動",
  "account.filters.posts_only": "帖文",
  "account.filters.replies_toggle": "顯示回覆",
  "account.follow": "關注",
  "account.follow_back": "追蹤對方",
  "account.follow_back_short": "追蹤對方",
  "account.follow_request": "追蹤請求",
  "account.follow_request_cancel": "取消請求",
  "account.follow_request_cancel_short": "取消",
  "account.follow_request_short": "請求",
  "account.followers": "追蹤者",
  "account.followers.empty": "尚未有人追蹤這位使用者。",
  "account.followers_counter": "{count, plural, other {{counter} 個追蹤者}}",
  "account.followers_you_know_counter": "你認識的 {counter} 人",
  "account.following": "正在追蹤",
  "account.follows.empty": "這位使用者尚未追蹤任何人。",
  "account.follows_you": "正追蹤你",
  "account.go_to_profile": "前往個人檔案",
  "account.hide_reblogs": "隱藏 @{name} 的轉推",
  "account.in_memoriam": "謹此悼念。",
  "account.joined_short": "加入於",
  "account.languages": "變更訂閱語言",
  "account.last_active": "上次活躍時間",
  "account.link_verified_on": "已於 {date} 檢查此連結的所有權",
  "account.locked_info": "這位使用者將私隱設定為「不公開」，會手動審批誰能關注他/她。",
  "account.media": "媒體",
  "account.mention": "提及 @{name}",
  "account.menu.add_to_list": "新增到列表",
  "account.menu.block": "封鎖帳號",
  "account.menu.block_domain": "封鎖 {domain}",
  "account.menu.copied": "複製帳號連結到剪貼簿",
  "account.menu.copy": "複製連結",
  "account.menu.direct": "私下提及",
  "account.menu.mention": "提及",
  "account.menu.mute": "帳號滅聲",
  "account.menu.note.description": "只有你見到",
  "account.menu.open_original_page": "在 {domain} 觀看",
  "account.menu.remove_follower": "移除追隨者",
  "account.menu.report": "擧報帳號",
  "account.menu.share": "分享…",
  "account.menu.unblock": "解除封鎖帳號",
  "account.menu.unblock_domain": "解除封鎖 {domain}",
  "account.menu.unmute": "解除帳號滅聲",
  "account.moved_to": "{name} 表示現在的新帳號是：",
  "account.mute": "將 @{name} 靜音",
  "account.mute_notifications_short": "靜音通知",
  "account.mute_short": "靜音",
  "account.muted": "靜音",
  "account.mutual": "你們已互相追蹤",
  "account.name.help.username": "{username} 係你喺呢個 Server 嘅 Account 嘅 Username，可能會有條友喺第二個 Server 用緊同一個 Username。",
  "account.name.help.username_self": "{username} 係你喺呢個 Server 嘅 Username，可能會有條友喺第二個 Server 用緊同一個 Username。",
  "account.name_info": "咩意思？",
  "account.no_bio": "未提供描述。",
  "account.node_modal.callout": "只有你可以見到個人筆記",
  "account.node_modal.edit_title": "編輯個人筆記",
  "account.node_modal.error_unknown": "未能儲存筆記",
  "account.node_modal.field_label": "個人筆記",
  "account.node_modal.save": "儲存",
  "account.node_modal.title": "新增個人筆記",
  "account.note.edit_button": "編輯",
  "account.note.title": "個人筆記（得你先睇到）",
  "account.open_original_page": "打開原始頁面",
  "account.posts": "帖文",
  "account.remove_from_followers": "移除追蹤者{name}",
  "account.report": "檢舉 @{name}",
  "account.requested_follow": "{name} 要求追蹤你",
  "account.share": "分享 @{name} 的個人檔案",
  "account.show_reblogs": "顯示 @{name} 的轉推",
  "account.timeline.pinned": "釘起咗",
  "account.timeline.pinned.view_all": "睇晒所有釘起咗嘅 Post",
  "account.unblock": "解除封鎖 @{name}",
  "account.unblock_domain": "解除封鎖網域 {domain}",
  "account.unblock_domain_short": "解除封鎖",
  "account.unblock_short": "解除封鎖",
  "account.unendorse": "不要在個人檔案中推薦",
  "account.unfollow": "取消追蹤",
  "account.unmute": "取消靜音 @{name}",
  "account.unmute_notifications_short": "解除靜音通知",
  "account.unmute_short": "解除靜音",
  "account_edit.bio.add_label": "增加個人簡介",
  "account_edit.bio.edit_label": "編輯個人簡介",
  "account_edit.bio.placeholder": "打少少嘢介紹吓自己等人認到你",
  "account_edit.bio.title": "個人簡介",
  "account_edit.bio_modal.add_title": "新增個人簡介",
  "account_edit.bio_modal.edit_title": "編輯個人簡介",
  "account_edit.column_button": "搞掂",
  "account_edit.column_title": "編輯個人資料",
  "account_edit.custom_fields.add_label": "增加欄目",
  "account_edit.custom_fields.edit_label": "修改欄目",
  "account_edit.custom_fields.reorder_button": "欄目重新排位",
  "account_edit.custom_fields.tip_title": "貼士：增加認證咗嘅 LINK",
  "account_edit.custom_fields.title": "自訂欄目",
  "account_edit.custom_fields.verified_hint": "我點可以增加認證咗嘅 LINK?",
  "account_edit.display_name.add_label": "增加顯示嘅名",
  "account_edit.display_name.edit_label": "修改顯示嘅名",
  "account_edit.display_name.title": "顯示嘅名",
  "account_edit.featured_hashtags.edit_label": "增加 #hashtag",
  "account_edit.featured_hashtags.placeholder": "等其他人認得你同更加快加入你鐘意嘅話提",
  "account_edit.featured_hashtags.title": "推薦嘅 #hashtag",
  "account_edit.field_actions.delete": "剷咗個欄目",
  "account_edit.field_actions.edit": "修改欄目",
  "account_edit.field_delete_modal.confirm": "你係咪堅想剷咗啲自訂嘅欄目？剷咗冇得返轉頭",
  "account_edit.field_delete_modal.delete_button": "剷咗佢",
  "account_edit.field_delete_modal.title": "剷咗個自訂欄目？",
  "account_edit.field_edit_modal.add_title": "增加自訂欄目",
  "account_edit.field_edit_modal.discard_confirm": "散啦",
  "account_edit.field_edit_modal.discard_message": "你有啲嘢改咗未 Save, 係咪真係要閃㗎？",
  "account_edit.field_edit_modal.edit_title": "修改自訂欄目",
  "admin.dashboard.daily_retention": "註冊後按天計算的使用者存留率",
  "admin.dashboard.monthly_retention": "註冊後按月計算的使用者存留率",
  "admin.dashboard.retention.average": "平均",
  "admin.dashboard.retention.cohort": "註冊月份",
  "admin.dashboard.retention.cohort_size": "新使用者",
  "admin.impact_report.instance_accounts": "將會被刪除的用戶個人檔案",
  "admin.impact_report.instance_followers": "本站用戶將失去的追隨者",
  "admin.impact_report.instance_follows": "其他用戶將失去的追隨者",
  "admin.impact_report.title": "影響摘要",
  "alert.rate_limited.message": "請在 {retry_time, time, medium} 後重試",
  "alert.rate_limited.title": "已限速",
  "alert.unexpected.message": "發生意外錯誤。",
  "alert.unexpected.title": "失敗！",
  "alt_text_badge.title": "替代文字",
  "alt_text_modal.cancel": "取消",
  "alt_text_modal.done": "完成",
  "announcement.announcement": "公告",
  "attachments_list.unprocessed": "（未處理）",
  "audio.hide": "隱藏音訊",
  "block_modal.remote_users_caveat": "我們會要求 {domain} 伺服器尊重你的決定。然而，由於部份伺服器可能以不同方式處理封鎖，因此無法保證一定會成功。公開帖文仍然有機會被未登入的使用者看見。",
  "block_modal.show_less": "顯示更少",
  "block_modal.show_more": "顯示更多",
  "block_modal.they_will_know": "對方會看到自己被封鎖。",
  "block_modal.title": "封鎖使用者？",
  "boost_modal.combo": "你下次可以按 {combo} 來跳過",
  "bundle_column_error.copy_stacktrace": "複製錯誤報告",
  "bundle_column_error.error.body": "無法提供請求的頁面。這可能是因為代碼出現錯誤或瀏覽器出現兼容問題。",
  "bundle_column_error.error.title": "大鑊！",
  "bundle_column_error.network.body": "嘗試載入此頁面時發生錯誤。這可能是因為您的網路連線或此伺服器暫時出現問題。",
  "bundle_column_error.network.title": "網絡錯誤",
  "bundle_column_error.retry": "重試",
  "bundle_column_error.return": "返回主頁",
  "bundle_column_error.routing.body": "找不到請求的頁面。您確定網址欄中的 URL 正確嗎？",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "關閉",
  "bundle_modal_error.retry": "重試",
  "closed_registrations.other_server_instructions": "基於Mastodon去中心化的特性，你可以在其他伺服器上創建賬戶並與本站互動。",
  "closed_registrations_modal.description": "目前無法在 {domain} 建立新帳號，但您並不一定需要擁有 {domain} 的帳號亦能使用 Mastodon 。",
  "closed_registrations_modal.find_another_server": "尋找另外的伺服器",
  "closed_registrations_modal.preamble": "Mastodon 是去中心化的，所以無論您在哪個伺服器建立帳號，都可以追蹤此伺服器上的任何人並與他們互動。您甚至可以自行搭建一個全新的伺服器！",
  "closed_registrations_modal.title": "在 Mastodon 註冊",
  "column.about": "關於",
  "column.blocks": "封鎖名單",
  "column.bookmarks": "書籤",
  "column.community": "本站時間軸",
  "column.direct": "私人提及",
  "column.directory": "瀏覽個人資料",
  "column.domain_blocks": "封鎖的服務站",
  "column.edit_list": "編輯列表",
  "column.favourites": "最愛",
  "column.firehose": "即時動態",
  "column.firehose_local": "本伺服器的即時動態",
  "column.firehose_singular": "即時動態",
  "column.follow_requests": "追蹤請求",
  "column.home": "主頁",
  "column.lists": "列表",
  "column.mutes": "靜音名單",
  "column.notifications": "通知",
  "column.pins": "置頂文章",
  "column.public": "跨站時間軸",
  "column_back_button.label": "返回",
  "column_header.hide_settings": "隱藏設定",
  "column_header.moveLeft_settings": "將欄左移",
  "column_header.moveRight_settings": "將欄右移",
  "column_header.pin": "置頂",
  "column_header.show_settings": "顯示設定",
  "column_header.unpin": "取消置頂",
  "column_search.cancel": "取消",
  "community.column_settings.local_only": "只顯示本站",
  "community.column_settings.media_only": "只顯示多媒體",
  "community.column_settings.remote_only": "只顯示外站",
  "compose.language.change": "更改語言",
  "compose.language.search": "搜尋語言...",
  "compose.published.body": "已發佈帖子",
  "compose.published.open": "打開",
  "compose.saved.body": "帖文已儲存",
  "compose_form.direct_message_warning_learn_more": "了解更多",
  "compose_form.encryption_warning": "Mastodon 上的帖文並未端對端加密。請不要透過 Mastodon 分享任何敏感資訊。",
  "compose_form.hashtag_warning": "由於此帖文並非公開，因此它不會列在標籤下。只有公開帖文才可以經標籤搜尋。",
  "compose_form.lock_disclaimer": "你的用戶狀態沒有{locked}，任何人都能立即關注你，然後看到「只有關注者能看」的文章。",
  "compose_form.lock_disclaimer.lock": "鎖定",
  "compose_form.placeholder": "你在想甚麼？",
  "compose_form.poll.duration": "投票期限",
  "compose_form.poll.multiple": "多選",
  "compose_form.poll.option_placeholder": "選項 {number}",
  "compose_form.poll.single": "單一選擇",
  "compose_form.poll.switch_to_multiple": "變更投票為允許多個選項",
  "compose_form.poll.switch_to_single": "變更投票為限定單一選項",
  "compose_form.poll.type": "風格",
  "compose_form.publish": "發佈",
  "compose_form.reply": "回覆",
  "compose_form.save_changes": "更新",
  "compose_form.spoiler.marked": "文字被警告隱藏",
  "compose_form.spoiler.unmarked": "文字沒有被隱藏",
  "compose_form.spoiler_placeholder": "內容警告 (選用)",
  "confirmation_modal.cancel": "取消",
  "confirmations.block.confirm": "封鎖",
  "confirmations.delete.confirm": "刪除",
  "confirmations.delete.message": "你確定要刪除這文章嗎？",
  "confirmations.delete.title": "刪除帖文？",
  "confirmations.delete_list.confirm": "刪除",
  "confirmations.delete_list.message": "你確定要永久刪除這列表嗎？",
  "confirmations.delete_list.title": "刪除列表？",
  "confirmations.discard_draft.post.title": "要捨棄文章的草稿？",
  "confirmations.discard_edit_media.confirm": "捨棄",
  "confirmations.discard_edit_media.message": "您在媒體描述或預覽有尚未儲存的變更。確定要捨棄它們嗎？",
  "confirmations.follow_to_list.title": "追蹤使用者？",
  "confirmations.logout.confirm": "登出",
  "confirmations.logout.message": "確定要登出嗎？",
  "confirmations.logout.title": "登出？",
  "confirmations.missing_alt_text.confirm": "新增替代文字",
  "confirmations.missing_alt_text.message": "你的貼文尚未附上替代文字。新增描述有助更多人存取其內容。",
  "confirmations.mute.confirm": "靜音",
  "confirmations.quiet_post_quote_info.dismiss": "不再提醒",
  "confirmations.quiet_post_quote_info.got_it": "知道了",
  "confirmations.redraft.confirm": "刪除並編輯",
  "confirmations.redraft.message": "你確定要移除並重新起草這篇帖文嗎？你將會失去最愛和轉推，而回覆也會與原始帖文斷開連接。",
  "confirmations.revoke_quote.message": "此操作無法還原。",
  "confirmations.revoke_quote.title": "移除貼文？",
  "confirmations.unblock.confirm": "解除封鎖",
  "confirmations.unblock.title": "解除封鎖 {name}？",
  "confirmations.unfollow.confirm": "取消追蹤",
  "confirmations.unfollow.title": "取消追蹤 {name}？",
  "confirmations.withdraw_request.confirm": "撤回請求",
  "confirmations.withdraw_request.title": "撤回追蹤{name}的請求？",
  "content_warning.hide": "隱藏嘟文",
  "content_warning.show": "仍要顯示",
  "content_warning.show_more": "顯示更多",
  "conversation.delete": "刪除對話",
  "conversation.mark_as_read": "標為已讀",
  "conversation.open": "檢視對話",
  "conversation.with": "與 {names}",
  "copy_icon_button.copied": "已複製到剪貼簿",
  "copypaste.copied": "已複製",
  "copypaste.copy_to_clipboard": "複製到剪貼簿",
  "directory.federated": "來自已知的聯盟網絡",
  "directory.local": "僅來自 {domain}",
  "directory.new_arrivals": "新內容",
  "directory.recently_active": "最近活躍",
  "disabled_account_banner.account_settings": "帳號設定",
  "disabled_account_banner.text": "您的帳號 {disabledAccount} 目前已停用。",
  "dismissable_banner.community_timeline": "這些是 {domain} 上用戶的最新公開帖文。",
  "dismissable_banner.dismiss": "關閉",
  "domain_block_modal.block": "封鎖伺服器",
  "domain_block_modal.block_account_instead": "封鎖 @{name} 即可",
  "domain_block_modal.they_can_interact_with_old_posts": "此伺服器的人們可與你的舊帖文互動。",
  "domain_block_modal.they_cant_follow": "此伺服器的人無法追蹤你。",
  "domain_block_modal.they_wont_know": "對方不會知道自己被封鎖。",
  "domain_block_modal.title": "封鎖網域？",
  "domain_block_modal.you_wont_see_posts": "你將看不到此伺服器使用者的帖文和通知。",
  "embed.instructions": "要內嵌此文章，請將以下代碼貼進你的網站。",
  "embed.preview": "看上去會是這樣：",
  "emoji_button.activity": "活動",
  "emoji_button.clear": "清除",
  "emoji_button.custom": "自訂",
  "emoji_button.flags": "旗幟",
  "emoji_button.food": "飲飲食食",
  "emoji_button.label": "加入表情符號",
  "emoji_button.nature": "自然",
  "emoji_button.not_found": "沒找到表情符號！！ (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "物品",
  "emoji_button.people": "人物",
  "emoji_button.recent": "常用",
  "emoji_button.search": "搜尋…",
  "emoji_button.search_results": "搜尋結果",
  "emoji_button.symbols": "符號",
  "emoji_button.travel": "旅遊景物",
  "empty_column.account_hides_collections": "這位使用者選擇不公開此資訊",
  "empty_column.account_suspended": "帳號已停權",
  "empty_column.account_timeline": "這裡還沒有嘟文！",
  "empty_column.account_unavailable": "無法取得個人資料",
  "empty_column.blocks": "你還沒有封鎖任何使用者。",
  "empty_column.bookmarked_statuses": "你還沒建立任何書籤。這裡將會顯示你建立的書籤。",
  "empty_column.community": "本站時間軸暫時未有內容，快寫一點東西來搶頭香啊！",
  "empty_column.direct": "你還沒有私人提及。當你發送或收到時，它將顯示在這裏。",
  "empty_column.domain_blocks": "尚未隱藏任何網域。",
  "empty_column.explore_statuses": "目前沒有熱門話題，請稍候再回來看看！",
  "empty_column.favourited_statuses": "你還沒有把帖文加入最愛。加入後，最愛的帖文將會在這裡顯示。",
  "empty_column.favourites": "還沒有人把這篇帖文加入最愛。當有人把它加入最愛，帖文將會在此顯示。",
  "empty_column.follow_requests": "您尚未收到任何追蹤請求。這裡將會顯示收到的追蹤請求。",
  "empty_column.followed_tags": "你還沒有追蹤標籤。當你追蹤後，標籤將顯示在此處。",
  "empty_column.hashtag": "這個標籤暫時未有內容。",
  "empty_column.home": "你還沒有關注任何使用者。快看看{public}，向其他使用者搭訕吧。",
  "empty_column.list": "這個列表暫時未有內容。",
  "empty_column.mutes": "你尚未靜音任何使用者。",
  "empty_column.notification_requests": "沒有新通知了！當有新通知時，會根據設定顯示在這裏。",
  "empty_column.notifications": "你沒有任何通知紀錄，快向其他用戶搭訕吧。",
  "empty_column.public": "跨站時間軸暫時沒有內容！快寫一些公共的文章，或者關注另一些服務站的用戶吧！你和本站、友站的交流，將決定這裏出現的內容。",
  "error.unexpected_crash.explanation": "由於發生系統故障或瀏覽器相容性問題，故無法正常顯示頁面。",
  "error.unexpected_crash.explanation_addons": "此頁面無法被正確顯示，這可能是由於瀏覽器的附加元件或網頁自動翻譯工具造成的。",
  "error.unexpected_crash.next_steps": "請嘗試重新整理頁面。如果狀況沒有進展，你可以使用不同的瀏覽器或 Mastodon 應用程式來檢視。",
  "error.unexpected_crash.next_steps_addons": "請嘗試停止使用這些附加元件然後重新載入頁面。如果問題沒有解決，你仍然可以使用不同的瀏覽器或 Mastodon 應用程式來檢視。",
  "errors.unexpected_crash.copy_stacktrace": "複製 stacktrace 到剪貼簿",
  "errors.unexpected_crash.report_issue": "舉報問題",
  "explore.suggested_follows": "使用者",
  "explore.trending_links": "最新消息",
  "explore.trending_statuses": "帖文",
  "explore.trending_tags": "標籤",
  "filter_modal.added.context_mismatch_explanation": "此過濾器類別不適用於您所存取帖文的情境。如果您想要此帖文被於此情境被過濾，您必須編輯過濾器。",
  "filter_modal.added.context_mismatch_title": "情境不符合！",
  "filter_modal.added.expired_explanation": "此過濾器類別已失效，您需要更新過期日期才能套用。",
  "filter_modal.added.expired_title": "過期的過濾器！",
  "filter_modal.added.review_and_configure": "若欲檢視並進一步配置此過濾器類別，請前往 {settings_link}。",
  "filter_modal.added.review_and_configure_title": "過濾器設定",
  "filter_modal.added.settings_link": "設定頁面",
  "filter_modal.added.short_explanation": "此帖文已被新增至以下過濾器類別：{title}。",
  "filter_modal.added.title": "已新增過濾器！",
  "filter_modal.select_filter.context_mismatch": "不適用於目前情境",
  "filter_modal.select_filter.expired": "已過期",
  "filter_modal.select_filter.prompt_new": "新類別：{name}",
  "filter_modal.select_filter.search": "搜尋或新增",
  "filter_modal.select_filter.subtitle": "使用既有類別，或創建一個新類別",
  "filter_modal.select_filter.title": "過濾此帖文",
  "filter_modal.title.status": "過濾一則帖文",
  "filtered_notifications_banner.title": "已過濾之通知",
  "firehose.all": "全部",
  "firehose.local": "本伺服器",
  "firehose.remote": "其他伺服器",
  "follow_request.authorize": "批准",
  "follow_request.reject": "拒絕",
  "follow_requests.unlocked_explanation": "即使您的帳號未上鎖，{domain} 的工作人員認為您可能會想手動審核來自這些帳號的追蹤請求。",
  "follow_suggestions.curated_suggestion": "編輯精選",
  "follow_suggestions.dismiss": "不再顯示",
  "follow_suggestions.featured_longer": "{domain} 團隊精選",
  "follow_suggestions.friends_of_friends_longer": "受你的追蹤對象歡迎",
  "follow_suggestions.hints.featured": "這個人檔案是由 {domain} 團隊精挑細選。",
  "follow_suggestions.hints.friends_of_friends": "這個人檔案在你追蹤的人當中很受歡迎。",
  "follow_suggestions.hints.most_followed": "這個人檔案是在 {domain} 上最多追蹤之一。",
  "follow_suggestions.hints.most_interactions": "這個人檔案最近在 {domain} 上備受關注。",
  "follow_suggestions.hints.similar_to_recently_followed": "這個人檔案與你最近追蹤的類似。",
  "follow_suggestions.personalized_suggestion": "個人化推薦",
  "follow_suggestions.popular_suggestion": "熱門推薦",
  "follow_suggestions.popular_suggestion_longer": "{domain} 熱門",
  "follow_suggestions.similar_to_recently_followed_longer": "與你最近追蹤的帳號相似",
  "follow_suggestions.view_all": "查看所有",
  "follow_suggestions.who_to_follow": "追蹤對象",
  "followed_tags": "已追蹤標籤",
  "footer.about": "關於",
  "footer.directory": "個人檔案目錄",
  "footer.get_app": "取得應用程式",
  "footer.keyboard_shortcuts": "鍵盤快速鍵",
  "footer.privacy_policy": "私隱政策",
  "footer.source_code": "查看原始碼",
  "footer.status": "狀態",
  "getting_started.heading": "開始使用",
  "hashtag.column_header.tag_mode.all": "以及{additional}",
  "hashtag.column_header.tag_mode.any": "或是{additional}",
  "hashtag.column_header.tag_mode.none": "而無需{additional}",
  "hashtag.column_settings.select.no_options_message": "找不到建議",
  "hashtag.column_settings.select.placeholder": "輸入主題標籤…",
  "hashtag.column_settings.tag_mode.all": "全部",
  "hashtag.column_settings.tag_mode.any": "任一",
  "hashtag.column_settings.tag_mode.none": "全不",
  "hashtag.column_settings.tag_toggle": "在這欄位加入額外的標籤",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} 名參與者} other {{counter} 名參與者}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} 篇帖文} other {{counter} 篇帖文}}",
  "hashtag.counter_by_uses_today": "今天有 {count, plural, one {{counter} 篇帖文} other {{counter} 篇帖文}}",
  "hashtag.follow": "追蹤主題標籤",
  "hashtag.unfollow": "取消追蹤主題標籤",
  "hashtags.and_other": "…及{count, plural, other {其他 # 個}}",
  "home.column_settings.show_reblogs": "顯示被轉推的文章",
  "home.column_settings.show_replies": "顯示回應文章",
  "home.hide_announcements": "隱藏公告",
  "home.pending_critical_update.body": "請盡快更新你的 Mastodon 伺服器！",
  "home.pending_critical_update.link": "查看更新",
  "home.pending_critical_update.title": "有重要的安全更新！",
  "home.show_announcements": "顯示公告",
  "ignore_notifications_modal.ignore": "忽略推播通知",
  "info_button.label": "幫助",
  "interaction_modal.on_another_server": "於不同伺服器",
  "interaction_modal.on_this_server": "於此伺服器",
  "intervals.full.days": "{number, plural, one {# 天} other {# 天}}",
  "intervals.full.hours": "{number, plural, one {# 小時} other {# 小時}}",
  "intervals.full.minutes": "{number, plural, one {# 分鐘} other {# 分鐘}}",
  "keyboard_shortcuts.back": "返回",
  "keyboard_shortcuts.blocked": "開啟封鎖名單",
  "keyboard_shortcuts.boost": "轉推",
  "keyboard_shortcuts.column": "把標示移動到其中一列",
  "keyboard_shortcuts.compose": "把標示移動到文字輸入區",
  "keyboard_shortcuts.description": "描述",
  "keyboard_shortcuts.down": "在列表往下移動",
  "keyboard_shortcuts.enter": "打開文章",
  "keyboard_shortcuts.favourite": "加入最愛",
  "keyboard_shortcuts.favourites": "打開最愛列表",
  "keyboard_shortcuts.federated": "打開跨站時間軸",
  "keyboard_shortcuts.heading": "鍵盤快速鍵",
  "keyboard_shortcuts.home": "開啟個人時間軸",
  "keyboard_shortcuts.hotkey": "快速鍵",
  "keyboard_shortcuts.legend": "顯示這個說明",
  "keyboard_shortcuts.load_more": "將焦點移至「讀取更多」按鈕",
  "keyboard_shortcuts.local": "開啟本站時間軸",
  "keyboard_shortcuts.mention": "提及作者",
  "keyboard_shortcuts.muted": "開啟靜音名單",
  "keyboard_shortcuts.my_profile": "開啟個人資料頁面",
  "keyboard_shortcuts.notifications": "開啟通知欄",
  "keyboard_shortcuts.open_media": "開啟媒體",
  "keyboard_shortcuts.pinned": "開啟釘選的文章清單",
  "keyboard_shortcuts.profile": "開啟作者的個人資料頁面",
  "keyboard_shortcuts.reply": "回覆",
  "keyboard_shortcuts.requests": "開啟關注請求名單",
  "keyboard_shortcuts.search": "把標示移動到搜索",
  "keyboard_shortcuts.spoilers": "顯示或隱藏被折疊的正文",
  "keyboard_shortcuts.start": "開啟「開始使用」欄位",
  "keyboard_shortcuts.toggle_hidden": "顯示或隱藏被標為敏感的文字",
  "keyboard_shortcuts.toggle_sensitivity": "顯示 / 隱藏媒體",
  "keyboard_shortcuts.toot": "新的文章",
  "keyboard_shortcuts.unfocus": "把標示移離文字輸入和搜索",
  "keyboard_shortcuts.up": "在列表往上移動",
  "lightbox.close": "關閉",
  "lightbox.next": "下一頁",
  "lightbox.previous": "上一頁",
  "limited_account_hint.action": "一律顯示個人檔案",
  "link_preview.author": "由 {name} 提供",
  "lists.add_member": "新增",
  "lists.create": "建立",
  "lists.delete": "刪除列表",
  "lists.done": "完成",
  "lists.edit": "編輯列表",
  "lists.remove_member": "移除",
  "lists.replies_policy.followed": "任何已關注的用戶",
  "lists.replies_policy.list": "列表中的用戶",
  "lists.replies_policy.none": "無人",
  "lists.save": "儲存",
  "lists.search": "搜尋",
  "load_pending": "{count, plural, other {# 個新項目}}",
  "loading_indicator.label": "載入中…",
  "media_gallery.hide": "隱藏",
  "moved_to_account_banner.text": "您的帳號 {disabledAccount} 目前已停用，因為您已搬家至 {movedToAccount}。",
  "mute_modal.hide_from_notifications": "隱藏通知",
  "mute_modal.hide_options": "隱藏選項",
  "mute_modal.indefinite": "直至我將對方解除靜音",
  "mute_modal.show_options": "顯示選項",
  "mute_modal.they_can_mention_and_follow": "對方能提及和追蹤你，但你將看不到對方。",
  "mute_modal.they_wont_know": "對方不會知道自己被靜音。",
  "mute_modal.title": "將使用者靜音？",
  "mute_modal.you_wont_see_mentions": "你將看不到提及他們的帖文。",
  "mute_modal.you_wont_see_posts": "他們仍能看到你的帖文，但你將看不到他們的。",
  "navigation_bar.about": "關於",
  "navigation_bar.advanced_interface": "在進階網頁介面打開",
  "navigation_bar.blocks": "封鎖名單",
  "navigation_bar.bookmarks": "書籤",
  "navigation_bar.direct": "私人提及",
  "navigation_bar.domain_blocks": "封鎖的服務站",
  "navigation_bar.favourites": "最愛",
  "navigation_bar.filters": "靜音詞彙",
  "navigation_bar.follow_requests": "追蹤請求",
  "navigation_bar.followed_tags": "已追蹤標籤",
  "navigation_bar.follows_and_followers": "追蹤及追蹤者",
  "navigation_bar.import_export": "匯入及匯出",
  "navigation_bar.lists": "列表",
  "navigation_bar.live_feed_local": "即時動態（本地）",
  "navigation_bar.live_feed_public": "即時動態（公開）",
  "navigation_bar.logout": "登出",
  "navigation_bar.more": "更多",
  "navigation_bar.mutes": "靜音名單",
  "navigation_bar.opened_in_classic_interface": "帖文、帳號及其他特定頁面將預設在經典網頁介面中打開。",
  "navigation_bar.preferences": "偏好設定",
  "navigation_bar.privacy_and_reach": "私隱及觸及",
  "navigation_bar.search": "搜尋",
  "not_signed_in_indicator.not_signed_in": "您需要登入才能存取此資源。",
  "notification.admin.report": "{name} 檢舉了 {target}",
  "notification.admin.sign_up": "{name} 已經註冊",
  "notification.favourite": "{name} 喜歡你的文章",
  "notification.follow": "{name} 開始追蹤你",
  "notification.follow_request": "{name} 要求追蹤你",
  "notification.label.mention": "提及",
  "notification.label.reply": "回覆",
  "notification.mention": "提及",
  "notification.mentioned_you": "{name} 已提及你",
  "notification.moderation-warning.learn_more": "了解更多",
  "notification.moderation_warning.action_delete_statuses": "你的部份帖文已被刪除。",
  "notification.moderation_warning.action_disable": "你的帳號已被停用。",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "你某些帖文已被標記為敏感內容。",
  "notification.moderation_warning.action_none": "你的帳號收到一則審核警告。",
  "notification.moderation_warning.action_sensitive": "從現在起，你的帖文將被標記為敏感內容。",
  "notification.moderation_warning.action_silence": "你的帳號已受到限制。",
  "notification.moderation_warning.action_suspend": "你的帳號已被停權。",
  "notification.own_poll": "你的投票已結束",
  "notification.reblog": "{name} 轉推你的文章",
  "notification.relationships_severance_event": "失去與 {name} 的連結",
  "notification.relationships_severance_event.account_suspension": "{from} 的管理員已將 {target} 停權，這表示你無法再收到他們的更新或與他們互動。",
  "notification.relationships_severance_event.domain_block": "{from} 的管理員已封鎖 {target}，包括你的 {followersCount} 位追蹤者和 {followingCount, plural, other {# 個你追蹤的帳號}}。",
  "notification.relationships_severance_event.learn_more": "了解更多",
  "notification.relationships_severance_event.user_domain_block": "你已封鎖 {target}，並移除了你的 {followersCount} 位追蹤者和你追蹤的 {followingCount, plural, other {# 個帳號}}。",
  "notification.status": "{name} 剛發表了文章",
  "notification.update": "{name} 編輯了帖文",
  "notification_requests.accept": "接受",
  "notification_requests.dismiss": "忽略",
  "notification_requests.edit_selection": "編輯",
  "notification_requests.exit_selection": "完成",
  "notification_requests.maximize": "最大化",
  "notification_requests.notifications_from": "來自 {name} 的通知",
  "notification_requests.title": "已過濾之通知",
  "notifications.clear": "清空通知紀錄",
  "notifications.clear_confirmation": "你確定要清空通知紀錄嗎？",
  "notifications.column_settings.admin.report": "新舉報：",
  "notifications.column_settings.admin.sign_up": "新註冊：",
  "notifications.column_settings.alert": "顯示桌面通知",
  "notifications.column_settings.favourite": "最愛：",
  "notifications.column_settings.filter_bar.advanced": "顯示所有分類",
  "notifications.column_settings.filter_bar.category": "快速篩選欄",
  "notifications.column_settings.follow": "新追蹤者：",
  "notifications.column_settings.follow_request": "新的追蹤請求：",
  "notifications.column_settings.group": "群組",
  "notifications.column_settings.mention": "提及你：",
  "notifications.column_settings.poll": "投票結果：",
  "notifications.column_settings.push": "推送通知",
  "notifications.column_settings.reblog": "轉推你的文章：",
  "notifications.column_settings.show": "在通知欄顯示",
  "notifications.column_settings.sound": "播放音效",
  "notifications.column_settings.status": "新的文章",
  "notifications.column_settings.unread_notifications.category": "未讀通知",
  "notifications.column_settings.unread_notifications.highlight": "突顯未讀通知",
  "notifications.column_settings.update": "編輯：",
  "notifications.filter.all": "全部",
  "notifications.filter.boosts": "轉推",
  "notifications.filter.favourites": "最愛",
  "notifications.filter.follows": "追蹤的使用者",
  "notifications.filter.mentions": "提及",
  "notifications.filter.polls": "投票結果",
  "notifications.filter.statuses": "已關注的用戶的最新動態",
  "notifications.grant_permission": "授予權限",
  "notifications.group": "{count} 條通知",
  "notifications.mark_as_read": "標記所有通知為已讀",
  "notifications.permission_denied": "本站不能發送桌面通知，因為瀏覽器先前拒絕了本站的桌面通知權限請求",
  "notifications.permission_denied_alert": "無法啟用桌面通知，因為瀏覽器先前拒絕了本站的桌面通知權限請求",
  "notifications.permission_required": "由於瀏覽器未有授予桌面通知權限，本站暫未能發送桌面通知。",
  "notifications.policy.accept": "接受",
  "notifications.policy.drop": "忽略",
  "notifications.policy.filter": "篩選",
  "notifications.policy.filter_new_accounts.hint": "在過去 {days, plural, other {# 天}}內建立",
  "notifications.policy.filter_new_accounts_title": "新帳號",
  "notifications.policy.filter_not_followers_hint": "包括追蹤你不到 {days, plural, other {# 天}}的人",
  "notifications.policy.filter_not_followers_title": "未追蹤你的人",
  "notifications.policy.filter_not_following_hint": "直至你手動核准他們",
  "notifications.policy.filter_not_following_title": "你未追蹤的人",
  "notifications.policy.filter_private_mentions_hint": "除非回覆你的提及或來自你追蹤的人，否則將被過濾",
  "notifications.policy.filter_private_mentions_title": "未經請求的私人提及",
  "notifications_permission_banner.enable": "啟用桌面通知",
  "notifications_permission_banner.how_to_control": "只要啟用桌面通知，便可在 Mastodon 網站沒有打開時收到通知。在已經啟用桌面通知的時候，你可以透過上面的 {icon} 按鈕準確控制哪些類型的互動會產生桌面通知。",
  "notifications_permission_banner.title": "不放過任何事情",
  "onboarding.follows.empty": "很遺憾，現在無法顯示任何結果。你可以嘗試搜尋或瀏覽探索頁面來找使用者來追蹤，或者稍後再試。",
  "onboarding.follows.search": "搜尋",
  "onboarding.profile.discoverable": "將個人檔案設為可被搜尋",
  "onboarding.profile.discoverable_hint": "當你在 Mastodon 上選擇可被搜尋時，你的帖文可能會出現在搜尋結果和熱門，你的個人檔案也可能被推薦給與你興趣相似的人。",
  "onboarding.profile.display_name": "顯示名稱",
  "onboarding.profile.display_name_hint": "你的全名或暱稱…",
  "onboarding.profile.note": "簡介",
  "onboarding.profile.note_hint": "你可以 @提及他人 或使用 #標籤…",
  "onboarding.profile.title": "個人檔案設定",
  "onboarding.profile.upload_avatar": "上載個人檔案頭像",
  "onboarding.profile.upload_header": "上載個人檔案橫幅圖片",
  "password_confirmation.exceeds_maxlength": "確認密碼欄超出了密碼長度限制",
  "password_confirmation.mismatching": "密碼確認不符",
  "picture_in_picture.restore": "還原影片播放器",
  "poll.closed": "已關閉",
  "poll.refresh": "重新整理",
  "poll.reveal": "查看結果",
  "poll.total_people": "{count, plural, one {# 人投票} other {# 人投票}}",
  "poll.total_votes": "{count, plural, one {# 票} other {# 票}}",
  "poll.vote": "投票",
  "poll.voted": "你已投票給這答案",
  "poll.votes": "{votes, plural, one {# 票} other {# 票}}",
  "poll_button.add_poll": "建立投票",
  "poll_button.remove_poll": "移除投票",
  "privacy.change": "調整私隱設定",
  "privacy.direct.long": "帖文提及的人",
  "privacy.private.long": "只有你的追蹤者",
  "privacy.private.short": "追蹤者",
  "privacy.public.long": "Mastodon 內外的任何人",
  "privacy.public.short": "公共",
  "privacy.unlisted.additional": "這與公開完全相同，但是你的帖文不會顯示在即時動態、標籤、探索和 Mastodon 的搜尋結果中，即使你的帳戶啟用了相關設定也好。",
  "privacy.unlisted.short": "半公開",
  "privacy_policy.last_updated": "最後更新 {date}",
  "privacy_policy.title": "私隱政策",
  "recommended": "推薦",
  "refresh": "重新整理",
  "relative_time.days": "{number}日前",
  "relative_time.full.days": "{number, plural, one {# 天} other {# 天}}前",
  "relative_time.full.hours": "{number, plural, one {# 小時} other {# 小時}}前",
  "relative_time.full.just_now": "剛剛",
  "relative_time.full.minutes": "{number, plural, one {# 分鐘} other {# 分鐘}}前",
  "relative_time.full.seconds": "{number, plural, one {# 秒} other {# 秒}}前",
  "relative_time.hours": "{number}小時前",
  "relative_time.just_now": "剛剛",
  "relative_time.minutes": "{number}分鐘前",
  "relative_time.seconds": "{number}秒前",
  "relative_time.today": "今天",
  "reply_indicator.attachments": "{count, plural, one {# 附件} other {# 附件}}",
  "reply_indicator.cancel": "取消",
  "reply_indicator.poll": "投票",
  "report.block": "封鎖",
  "report.block_explanation": "你將不會看到他們的帖文。他們將無法看到你的帖文或追隨你。他們將發現自己被封鎖了。",
  "report.categories.legal": "法律",
  "report.categories.other": "其他",
  "report.categories.spam": "垃圾訊息",
  "report.categories.violation": "內容違犯一項或多項伺服器規則",
  "report.category.subtitle": "選擇最佳選項",
  "report.close": "完成",
  "report.comment.title": "還有甚麼你想讓我們知道的嗎？",
  "report.forward": "轉寄到 {target}",
  "report.forward_hint": "這個帳戶屬於其他服務站。要向該服務站發送匿名的舉報訊息嗎？",
  "report.mute": "靜音",
  "report.mute_explanation": "你將不會看到他們的帖文。他們仍然能夠追蹤你和查看你的帖文，並且不會知道他們自己已被靜音。",
  "report.next": "繼續",
  "report.placeholder": "額外訊息",
  "report.reasons.dislike": "我不喜歡它",
  "report.reasons.dislike_description": "這不是你想看到的東西",
  "report.reasons.legal": "這是違法",
  "report.reasons.legal_description": "你認為它違反了你或伺服器所在國家的法律",
  "report.reasons.other": "其他原因",
  "report.reasons.other_description": "這個問題不屬於其他類別",
  "report.reasons.spam": "這是垃圾訊息",
  "report.reasons.spam_description": "惡意連結、虛假互動或重複回覆",
  "report.reasons.violation": "它違反了伺服器規則",
  "report.reasons.violation_description": "你知道它違反了特定規則",
  "report.rules.subtitle": "選擇所有適用選項",
  "report.rules.title": "違反了哪些規則？",
  "report.statuses.subtitle": "選擇所有適用選項",
  "report.statuses.title": "有沒有能夠佐證這個檢舉的帖文？",
  "report.submit": "提交",
  "report.target": "舉報",
  "report.thanks.take_action": "以下是控制你在 Mastodon 上看到的內容的選項：",
  "report.thanks.take_action_actionable": "在我們審核期間，你可以對 @{name} 採取以下行動：",
  "report.thanks.title": "不想看到這個嗎？",
  "report.thanks.title_actionable": "感謝你的檢舉，我們會著手調查。",
  "report.unfollow": "取消追蹤 @{name}",
  "report.unfollow_explanation": "你正在追蹤此帳號。如果不想再在首頁時間軸看到他們的帖文，請取消追蹤。",
  "report_notification.attached_statuses": "已附上 {count, plural, one {{count} 則帖文} other {{count} 則帖文}}",
  "report_notification.categories.legal": "法律",
  "report_notification.categories.other": "其他",
  "report_notification.categories.other_sentence": "其他",
  "report_notification.categories.spam": "垃圾訊息",
  "report_notification.categories.violation": "違反規則",
  "report_notification.open": "打開檢舉報告",
  "search.no_recent_searches": "沒有近期的搜尋紀錄",
  "search.placeholder": "搜尋",
  "search.quick_action.account_search": "符合的個人檔案 {x}",
  "search.quick_action.go_to_account": "前往個人檔案 {x}",
  "search.quick_action.go_to_hashtag": "前往主題標籤 {x}",
  "search.quick_action.open_url": "在 Mastodon 中打開網址",
  "search.quick_action.status_search": "符合的帖文 {x}",
  "search.search_or_paste": "搜尋或貼上網址",
  "search_popout.full_text_search_disabled_message": "在 {domain} 上無法使用。",
  "search_popout.full_text_search_logged_out_message": "登入後才可使用。",
  "search_popout.language_code": "ISO 語言代碼",
  "search_popout.options": "搜尋選項",
  "search_popout.quick_actions": "快速動作",
  "search_popout.recent": "最近的搜尋",
  "search_popout.specific_date": "指定日期",
  "search_popout.user": "使用者",
  "search_results.accounts": "個人檔案",
  "search_results.all": "全部",
  "search_results.hashtags": "標籤",
  "search_results.see_all": "顯示全部",
  "search_results.statuses": "文章",
  "server_banner.about_active_users": "在最近 30 天內內使用此伺服器的人 (月活躍用戶)",
  "server_banner.active_users": "活躍用戶",
  "server_banner.administered_by": "管理者：",
  "server_banner.server_stats": "伺服器統計：",
  "sign_in_banner.create_account": "建立帳號",
  "sign_in_banner.sign_in": "登入",
  "sign_in_banner.sso_redirect": "登入或註冊",
  "status.admin_account": "開啟 @{name} 的管理介面",
  "status.admin_domain": "打開 {domain} 管理介面",
  "status.admin_status": "在管理介面開啟這篇文章",
  "status.block": "封鎖 @{name}",
  "status.bookmark": "書籤",
  "status.cancel_reblog_private": "取消轉推",
  "status.cannot_reblog": "這篇文章無法被轉推",
  "status.copy": "將連結複製到文章中",
  "status.delete": "刪除",
  "status.detailed_status": "詳細對話內容",
  "status.direct": "私下提及 @{name}",
  "status.direct_indicator": "私人提及",
  "status.edit": "編輯",
  "status.edited": "最後編輯於 {date}",
  "status.edited_x_times": "Edited {count, plural, one {{count} 次} other {{count} 次}}",
  "status.favourite": "最愛",
  "status.filter": "篩選此帖文",
  "status.history.created": "{name} 於 {date} 建立",
  "status.history.edited": "{name} 於 {date} 編輯",
  "status.load_more": "載入更多",
  "status.media.open": "點擊以打開",
  "status.media.show": "點擊以顯示",
  "status.media_hidden": "隱藏媒體內容",
  "status.mention": "提及 @{name}",
  "status.more": "更多",
  "status.mute": "把 @{name} 靜音",
  "status.mute_conversation": "靜音對話",
  "status.open": "展開文章",
  "status.pin": "置頂到資料頁",
  "status.read_more": "閱讀更多",
  "status.reblog": "轉推",
  "status.reblogged_by": "{name} 轉推",
  "status.reblogs.empty": "還未有人轉推。有的話會顯示在這裡。",
  "status.redraft": "刪除並編輯",
  "status.remove_bookmark": "移除書籤",
  "status.replied_to": "回覆 {name}",
  "status.reply": "回應",
  "status.replyAll": "回應所有人",
  "status.report": "舉報 @{name}",
  "status.sensitive_warning": "敏感內容",
  "status.share": "分享",
  "status.show_less_all": "全部收起",
  "status.show_more_all": "全部展開",
  "status.show_original": "顯示原文",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.translate": "翻譯",
  "status.translated_from_with": "使用 {provider} 翻譯 {lang}",
  "status.uncached_media_warning": "無法預覽",
  "status.unmute_conversation": "對話解除靜音",
  "status.unpin": "解除置頂",
  "subscribed_languages.lead": "更改後，只有所選語言的帖文會出現在你的主頁和列表時間軸上。選擇「無」以接收所有語言的帖文。",
  "subscribed_languages.save": "儲存變更",
  "subscribed_languages.target": "變更 {target} 的訂閱語言",
  "tabs_bar.home": "主頁",
  "tabs_bar.menu": "功能表",
  "tabs_bar.notifications": "通知",
  "tabs_bar.publish": "新嘟文",
  "tabs_bar.search": "搜尋",
  "time_remaining.days": "剩餘 {number, plural, one {# 天} other {# 天}}",
  "time_remaining.hours": "剩餘 {number, plural, one {# 小時} other {# 小時}}",
  "time_remaining.minutes": "剩餘 {number, plural, one {# 分鐘} other {# 分鐘}}",
  "time_remaining.moments": "剩餘時間",
  "time_remaining.seconds": "剩餘 {number, plural, one {# 秒} other {# 秒}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} 人} other {{counter} 人}} 於過去 {days, plural, one {日} other {{days} days}} 之間",
  "trends.trending_now": "現在流行",
  "ui.beforeunload": "如果你現在離開 Mastodon，你的草稿內容將會被丟棄。",
  "units.short.billion": "{count}B",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}K",
  "upload_area.title": "將檔案拖放至此上載",
  "upload_button.label": "加入圖片、影片或音訊檔",
  "upload_error.limit": "已達到檔案上傳限制。",
  "upload_error.poll": "不允許在投票上傳檔案。",
  "upload_form.edit": "編輯",
  "upload_progress.label": "上載中……",
  "upload_progress.processing": "處理中...",
  "username.taken": "這個使用者名稱已被使用。試試另一個",
  "video.close": "關閉影片",
  "video.download": "下載檔案",
  "video.exit_fullscreen": "退出全螢幕",
  "video.expand": "展開影片",
  "video.fullscreen": "全螢幕",
  "video.hide": "隱藏影片",
  "video.pause": "暫停",
  "video.play": "播放",
  "video.volume_down": "調低音量",
  "video.volume_up": "調高音量",
  "visibility_modal.save": "儲存"
}
